export default "__VITE_ASSET__Bkkdkzuy__"